import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {InventoryItemContainerModel, InventoryItemQueryCriteria} from '../../../../../../models/aggregates/erp/inventory';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {InventoryItemHdrQueryCriteriaClass, InventoryItemHdrCriteriaModelQuery} from '../../../criteria/inventory-item-hdr-criteria.model';
import {ApiResponseModel, BasicApiResponseModel, PagingResponseModel} from '../../shared/api-response.model';
import {Core2Config} from '../../shared/core2Config';
import {ApiVisa} from '../../shared/api-visa.model';


@Injectable({
  providedIn: 'root'
})
export class InventoryItemService extends BaseApiTemplateService<InventoryItemContainerModel> {
  protected apiUrl: string;
  readonly url = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + + Core2Config.INV_PREFIX + "inv-items";

  constructor(http: HttpClient) {
    super();
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.INV_PREFIX + "inv-items";
    this.httpClient = http;
  }

  public postByCriteriaPromise(queryCriteria: InventoryItemQueryCriteria, visa: ApiVisa):
    Promise<PagingResponseModel<InventoryItemContainerModel>> {
    const UrlByCriteria = this.apiUrl + '/query?' + queryCriteria;
    this.apiUrl = visa.api_domain_url + this.endpoint_path;
    console.log('UrlByCriteria: ', UrlByCriteria);
    return this.httpClient.post<PagingResponseModel<InventoryItemContainerModel>>(
      this.apiUrl + '/query',
      queryCriteria,
      this.getHttpHeader(visa)
    ).toPromise();
  }

  public postItemPromise(
    dtoObject: InventoryItemContainerModel, visa: ApiVisa
  ): Promise<BasicApiResponseModel<InventoryItemContainerModel>> {
    this.apiUrl = visa.api_domain_url + this.endpoint_path;
    return this.httpClient.post<BasicApiResponseModel<InventoryItemContainerModel>>(
      this.apiUrl,
      dtoObject,
      this.getHttpHeader(visa)
    ).toPromise();
  }

  public editItemPromise(dtoObject: InventoryItemContainerModel, visa: ApiVisa
  ): Promise<BasicApiResponseModel<InventoryItemContainerModel>> {
    this.apiUrl = visa.api_domain_url + this.endpoint_path;
    return this.httpClient.put<BasicApiResponseModel<InventoryItemContainerModel>>(
      this.apiUrl, dtoObject, this.getHttpHeader(visa))
      .toPromise();
  }

  getPromiseByCriteria(
    visa: ApiVisa, criteria?: InventoryItemHdrQueryCriteriaClass
  ): Promise<ApiResponseModel<InventoryItemContainerModel>> {
    const buildDocCriteria = new InventoryItemHdrCriteriaModelQuery(criteria);
    console.log('buildDocCriteria: ', buildDocCriteria);
    console.log('OverRide: ', buildDocCriteria.query);
    this.apiUrl = visa.api_domain_url + this.endpoint_path + '/query?' + buildDocCriteria.query;
    const UrlByCriteria = this.apiUrl + '/query?' + buildDocCriteria.query;
    //  const UrlByCriteria = this.apiUrl + '/query?' + buildDocCriteria.query + ' offset ' + buildDocCriteria.voucherHdrCriteria.offset * buildDocCriteria.voucherHdrCriteria.limit + ' limit ' + buildDocCriteria.voucherHdrCriteria.limit;
    console.log('UrlByCriteria: ', UrlByCriteria);
    return this.httpClient.get<ApiResponseModel<InventoryItemContainerModel>>
    ( this.apiUrl, this.getHttpHeader(visa))
      .toPromise();
  }

}
